import axiosInstance from "../api";
import { sessionFailed, sessionLoading, setAuth } from "./slice";

/*
 * Asking the server who is signed in.
 *
 * The dashboard used to trust the profile and permissions it saved at sign-in
 * forever. When a bad renewal left a token behind with nothing else saved,
 * the menu was built from nothing and the sidebar was blank until the next
 * sign-in. Now every boot asks GET admin/auth/profile and the saved copy is
 * only a cache (see auth/slice.js).
 */

export const SESSION_PATH = "admin/auth/profile";

/**
 * The session in whichever shape the backend sends: `{profile, permission}`
 * (the login shape), or — from a backend not yet deployed — the bare
 * profile, in which case the saved permissions stand.
 * Null when the body is not a session at all.
 */
export const readSessionPayload = (body) => {
  const data = body?.response;
  if (!data || typeof data !== "object") return null;
  if (data.profile && typeof data.profile === "object") {
    return {
      profile: data.profile,
      permissions: Array.isArray(data.permission) ? data.permission : undefined,
    };
  }
  if (data.id != null) return { profile: data, permissions: undefined };
  return null;
};

/**
 * Load the session from the server and store it. Resolves true when stored.
 * A session the server refuses ends in the sign-in page through the axios
 * layer; anything else (no connection, a bad answer) marks the load failed
 * and leaves the cached copy standing.
 */
export const loadSession = () => async (dispatch) => {
  dispatch(sessionLoading());
  try {
    const response = await axiosInstance.get(SESSION_PATH);
    const session = readSessionPayload(response?.data);
    if (!session) {
      dispatch(sessionFailed());
      return false;
    }
    dispatch(setAuth(session));
    return true;
  } catch {
    dispatch(sessionFailed());
    return false;
  }
};
